import { FC, ReactNode, useMemo } from 'react';

import { MessagingContext, MessagingDeps } from './context';

export type MessagingDepsProviderProps = MessagingDeps & {
  children: ReactNode;
};

/**
 * Supplies the app-specific transport/logger/metrics to the messaging lib.
 * Mount once at the app root, above any messaging consumers, e.g.:
 *
 *   <MessagingDepsProvider transport={post} logger={logger} metrics={metrics}>
 *     ...
 *   </MessagingDepsProvider>
 *
 * Named *Deps*Provider to avoid colliding with the `MessagingProvider` enum
 * (Pusher/Ably) in ./types/messaging.
 */
export const MessagingDepsProvider: FC<MessagingDepsProviderProps> = ({ transport, logger, metrics, children }) => {
  const value = useMemo<MessagingDeps>(() => ({ transport, logger, metrics }), [transport, logger, metrics]);

  return <MessagingContext.Provider value={value}>{children}</MessagingContext.Provider>;
};
